import { Brand } from '../effect';

/**
 * RFC 5322 compliant email regex pattern
 */
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

/**
 * Validates if a string is a valid email address after trimming leading and trailing whitespace.
 */
export const isValidEmail = (email: string): boolean => EMAIL_REGEX.test(email.trim());

export type EmailUriConfig = {
  body?: string;
  subject?: string;
  to: string;
};

export type EmailUri = Brand.Brand<'EmailUri'> & string;

export const EmailUri = Brand.nominal<EmailUri>();

export const createEmailUri = ({ body, subject, to }: EmailUriConfig): EmailUri => {
  // eslint-disable-next-line fp/no-let
  let uri = `mailto:${to}`;
  // eslint-disable-next-line fp/no-mutation
  if (subject) uri += `?subject=${subject}`;
  // eslint-disable-next-line fp/no-mutation
  if (body) uri += `&body=${body}`;
  return EmailUri(encodeURI(uri));
};
